import { NewFooter } from '#bv/newui/NewFooter'
import { NewHeader } from '#bv/newui/NewHeader'

export function NewShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="nv-app">
      <div className="nv-bg" aria-hidden />
      <NewHeader />
      <main className="nv-main">{children}</main>
      <NewFooter />
    </div>
  )
}

